<template>
    <div class="title">
        <div class="row row-left">
            <slot name="back"/>
            <h4 class="title__medium"> {{ title }}</h4>
        </div>
        <BaseIconButton @click.native="close()">
            <template #icon>
                <i class="material-icons close">close</i>
            </template>
        </BaseIconButton>
    </div>
</template>

<script>
import BaseIconButton from "@/new-design/shared/ui/buttons/BaseIconButton.vue"

export default {
    name: "BaseWidgetTitle",
    components: {BaseIconButton},
    props: {
        title: {
            type: String,
        },
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.title {
    padding: 18px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--System-OnSurface);
}

.row-left {
    gap: 8px;
}

i {
    cursor: pointer;
}
</style>
